import React, { Component } from 'react';
import { Tree } from 'react-d3-tree';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import FamilytreeStyles from './FamilytreeStyles';
import PedigreeHelper from './PedigreeHelper';

const styles = {
  treeDiv: {
    textAlign: '-webkit-center',
    height: '100%',
    background: 'rgba(0, 0, 0, 0.04)',
  },
  fatherLabel: {
    cursor: 'pointer',
    width: 'fit-content',
  },
  fatherName: {
    lineHeight: 1,
    fontSize: FamilytreeStyles.styles.nodes.node.name.fontSize,
  },
  fatherAttributes: {
    fontSize: 'smaller',
    color: '#777',
    fontWeight: 700,
  },
};

export class Familytree extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [{ name: props.activeElephant.name }],
      center: { x: 0, y: 0 },
      father: null,
    };

    this.redirectToNewElephant = this.redirectToNewElephant.bind(this);
  }

  componentDidMount() {
    const { activeElephant: { pedigrees: treeData }, activeElephant } = this.props;
    let nestedPedigree;
    nestedPedigree = PedigreeHelper
      .convertFlatJSONPedigreeToNestedMaternalPedigree(treeData, activeElephant.pk);
    const father = PedigreeHelper.getFatherOf(activeElephant.pk, treeData);
    this.setFather(father);
    if (nestedPedigree.length <= 0) {
      nestedPedigree = [{
        name: activeElephant.name || 'Name not found',
        elephantId: activeElephant.pk,
        nodeSvgShape: PedigreeHelper.getNodeShape(activeElephant, activeElephant.pk),
        attributes: {
          num: activeElephant.num,
          birth: activeElephant.birth,
          sex: activeElephant.sex,
        },
      }];
    }
    this.setState({ treeData: nestedPedigree });
    this.saveCenterCoordinatesToState();
  }

  setFather(fatherElephant) {
    if (fatherElephant) this.setState({ father: fatherElephant });
    else this.setState({ father: null });
  }

  saveCenterCoordinatesToState() {
    const dimensions = this.treeContainer.getBoundingClientRect();
    this.setState({ center: { x: dimensions.width / 2, y: 40 } });
  }

  redirectToNewElephant(nodeData) {
    const { nodeClick } = this.props;
    nodeClick(nodeData.elephantId);
  }

  generateFatherLabel(father) {
    const { classes } = this.props;
    return (
      <div className={classes.fatherLabel}>
        <Typography>
          {'Father: '}
        </Typography>
        <Typography
          className={classes.fatherName}
          onClick={() => this.redirectToNewElephant({ elephantId: father.pk })}
        >
          {father.name}
        </Typography>
        <Typography
          className={classes.fatherAttributes}
          onClick={() => this.redirectToNewElephant({ elephantId: father.pk })}
        >
          {`num: ${father.num}, birth: ${father.birth}`}
        </Typography>
      </div>
    );
  }

  render() {
    const { treeData, center, father } = this.state;
    const { classes } = this.props;

    const fatherLabel = father && this.generateFatherLabel(father);

    if (treeData.length > 0) {
      return (
        <div className={classes.treeDiv} ref={(tc) => { this.treeContainer = tc; }}>
          {fatherLabel}
          <Tree
            data={treeData}
            translate={center}
            orientation="vertical"
            nodeSvgShape={FamilytreeStyles.nodeSvgShape}
            collapsible={false}
            onClick={this.redirectToNewElephant}
            textLayout={FamilytreeStyles.textLayout}
            styles={FamilytreeStyles.styles}
            pathFunc="elbow"
            separation={{ siblings: 1.5, nonSiblings: 2 }}
          />
        </div>
      );
    }

    return <div className="treediv" ref={(tc) => { this.treeContainer = tc; }} />;
  }
}

Familytree.defaultProps = {
  classes: {},
};

Familytree.propTypes = {
  activeElephant: PropTypes.shape({
    pk: PropTypes.number.isRequired,
    num: PropTypes.string,
    name: PropTypes.string,
    calf_num: PropTypes.string,
    sex: PropTypes.oneOf(['M', 'F', 'UKN']),
    birth: PropTypes.string,
    cw: PropTypes.string,
    age_capture: PropTypes.number,
    camp: PropTypes.shape(),
    reserach: PropTypes.string,
    pedigrees: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  }).isRequired,
  nodeClick: PropTypes.func.isRequired,
  classes: PropTypes.shape(),
};

export default withStyles(styles)(Familytree);



// WEBPACK FOOTER //
// ./src/components/familytree/Familytree.jsx